import { DivWrapper, DropdownMenu, DivList, DropdownToggle, SpanArrow, DivTitle } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import React, { FC } from 'react';
import clsx from 'clsx';
import { getInitialValue, getSortItem } from './utils';
import { TCombinedDropdownLabel } from './types';
import FnPerfectScrollbar from '../../elements/FnPerfectScrollbar/index';
import { FnPerfectScrollbarVariants } from '../../elements/FnPerfectScrollbar/constants';

type TProps = {
  propertyValue: string;
  propertyLabel: string;
  value: any;
  options: Record<string, any>[];
  onChange: (value: any) => void;
  propertiesLabelCombined?: TCombinedDropdownLabel;
  title?: string;
  placeholder?: string;
  keyName?: string;
  isPlaceholderIncluded?: boolean;
  disabled?: boolean;
};

const FnDropdown: FC<TProps> = ({
  propertyValue,
  propertyLabel,
  propertiesLabelCombined = null,
  value,
  options = [],
  onChange,
  title = '',
  placeholder = '',
  keyName = '',
  isPlaceholderIncluded = false,
  disabled = false
}) => {
  const initialValue = getInitialValue(value, options, propertyValue, propertyLabel, propertiesLabelCombined);

  return (
    <DivWrapper className={clsx({ ['disabled']: disabled })}>
      <Dropdown>
        {title && <DivTitle>{title}</DivTitle>}
        <DropdownToggle variant="outline-primary">
          {initialValue ? initialValue : placeholder}
          <SpanArrow>
            <FontAwesomeIcon icon={faAngleDown} />
          </SpanArrow>
        </DropdownToggle>
        <DropdownMenu>
          <FnPerfectScrollbar component="div" styled variant={FnPerfectScrollbarVariants.Secondary}>
            <DivList>
              {isPlaceholderIncluded && placeholder && (
                <Dropdown.Item as="li" onClick={() => onChange(null)}>
                  {placeholder}
                </Dropdown.Item>
              )}
              {options.map((sortItem) => (
                <Dropdown.Item
                  as="li"
                  key={keyName ? sortItem[propertyValue][keyName] : sortItem[propertyValue]}
                  onClick={() => onChange(sortItem[propertyValue])}
                  className={clsx({ ['active']: sortItem[propertyValue] === value })}
                >
                  {getSortItem(sortItem, propertyLabel, propertiesLabelCombined)}
                </Dropdown.Item>
              ))}
            </DivList>
          </FnPerfectScrollbar>
        </DropdownMenu>
      </Dropdown>
    </DivWrapper>
  );
};

export default FnDropdown;
